export enum QuestionAnswerRoutes {
  BasePrefix = "qa",
  ById = ":qaId",
  Search = "search"
}
